<template lang="pug">
  .checkbox-element(v-if="label")
    validation-provider(ref="field" :rules="rules" v-slot="{ errors }")
      input.hidden(type="checkbox" v-model="active")
      component.preview(:is="wrapperTag" v-bind="wrapperProps" @click="select")
        .icon
          component.checkbox(:is="checkboxTag" v-bind="checkboxProps" @click.prevent.stop="check")
            svg(
              v-if="active"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            )
              //- d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
              //- d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              path(
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.3"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              )
            .empty-checkbox(v-else)
              .circle
        .data
          component.field-preview(:is="labelTag" v-bind="labelProps" @click="showDetails")
            fieldset.form-field
              .field-value {{ label }}
              p.help.is-danger(v-if="errors && errors.length") Dies ist ein Pflichtfeld
      hr.my-4(v-if="showDivider")

      portal(to="modals")
        Modal(v-if="showModal" size="md" @dismiss="showModal = false" @close="showModal = false")
          .p-4.bg-gray-200.rounded
            h2.title.text-xl.mb-2(v-if="details && details.title") {{ details.title }}
            .content(v-html="details.text")
</template>

<script>
import { get } from '@/helpers';

import Modal from '@/components/Modal';

export default {
  name: 'Checkbox',
  props: {
    data: {
      type: Object,
      required: true
    },
    showDivider: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    active: false,
    showModal: false
  }),
  components: {
    Modal
  },
  computed: {
    detailsSettings() {
      const settings = this.data.settings || [];
      const details = settings.find(el => el.key === 'details');
      return get(details, 'value') || 'none';
    },
    wrapperTag() {
      let tag = 'a';
      if (this.detailsSettings !== 'none') tag = 'div';
      return tag;
    },
    wrapperProps() {
      let props = {};
      if (this.wrapperTag === 'a') {
        props.href = '#';
      }
      return props;
    },
    checkboxTag() {
      let tag = 'a';
      if (this.wrapperTag === 'a') tag = 'div';
      return tag;
    },
    checkboxProps() {
      let props = {};
      if (this.checkboxTag === 'a') {
        props.href = '#';
      }
      return props;
    },
    labelTag() {
      let tag = 'a';
      if (this.wrapperTag === 'a') tag = 'div';
      else if (this.detailsSettings === 'link') {
        if (!this.hyperlink) tag = 'div';
        else {
          if (this.path) tag = 'router-link';
          else if (this.href) tag = 'a';
        }
      }
      return tag;
    },
    labelProps() {
      let props = {};

      if (this.detailsSettings === 'link') {
        switch (this.labelTag) {
          case 'router-link':
            props.to = this.path;
            break;

          case 'a':
            props.title = this.details?.title;
            props.href = this.href;
            props.target = this.target;
            break;
        }
      } else if (this.labelTag === 'a') {
        props.href = '#';
      }

      return props;
    },
    rules() {
      let required = true;

      const contents = this.data.contents || [];
      const label = contents.find(el => el.key === 'label');
      const settings = get(label, 'settings') || [];
      const setting = settings.find(el => el.key === 'required');
      if (setting) {
        required = ['true', '1', 'yes', true].includes(setting.value);
      }

      let rules = {};
      if (required) rules.required = { allowFalse: false };
      return rules;
    },
    label() {
      const contents = this.data.contents || [];
      const label = contents.find(el => el.key === 'label');
      return get(label, 'title') || '';
    },
    details() {
      const contents = this.data.contents || [];
      return contents.find(el => el.key === 'details');
    },
    hyperlink() {
      return get(this.details, 'hyperlink');
    },
    href() {
      let href = false;

      if (this.hyperlink?.type !== 'internal' && get(this.hyperlink, 'href')) {
        const link = this.hyperlink.href;
        switch (this.hyperlink?.type) {
          case 'external':
            if (!link.startsWith('https://') && !link.startsWith('http://')) href = `https://${link}`;
            else href = link;
            break;

          case 'mailto':
            href = `mailto:${link}`;
            break;

          case 'tel':
            href = `tel:${link}`;
            break;
        }
      }

      return href;
    },
    target() {
      return get(this.hyperlink, 'target') || '_self';
    },
    path() {
      if (this.hyperlink?.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
        return this.hyperlink.menuItem.path;
      else return false;
    }
  },
  methods: {
    select(event) {
      if (this.wrapperTag === 'a') {
        event.preventDefault();
        event.stopPropagation();
        this.check();
      }
    },
    check() {
      this.active = !this.active;
      this.$nextTick(this.$refs.field.validate);
    },
    showDetails(event) {
      if (this.detailsSettings === 'modal') {
        event.preventDefault();
        event.stopPropagation();
        this.showModal = true;
      }
      event.returnValue = true;
    }
  }
};
</script>

<style lang="sass" scoped>
.empty-checkbox
  @apply flex justify-center items-center
  width: 3rem
  height: 3rem
  .circle
    @apply border-2 border-gray-400
    width: 1.5rem
    height: 1.5rem
    border-radius: 50%
a.checkbox
  &:hover,
  &:focus
    .circle
      border-color: var(--color-primary)
a.preview
  &:hover,
  &:focus
    .circle
      border-color: var(--color-primary)
a.field-preview
  text-decoration: none
</style>
